class CartDrawerUpsells extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-upsell-variant-id]');
      if (button) this.addToCart(button);
    });
  }

  addToCart(button) {
    if (button.classList.contains('loading')) return;
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      items: [{ id: Number(button.dataset.upsellVariantId), quantity: 1 }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          console.error(parsedState.description || parsedState.message);
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsells', cartData: parsedState });
        }

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(parsedState);
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  }
}

customElements.define('cart-drawer-upsells', CartDrawerUpsells);
